(function () {
  'use strict';

  function getMap(variantSelectsEl) {
    const script = variantSelectsEl.querySelector('script[id^="variant-display-names-"]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch {
      return null;
    }
  }

  function getValueMap(map, optionName) {
    if (map[optionName] && typeof map[optionName] === 'object') return map[optionName];
    return map;
  }

  function applyMap(el, map) {
    const optionNames = map._options || {};

    // Option name labels (legend for button/swatch, <label> for dropdown)
    el.querySelectorAll('legend, label.form__label').forEach((label) => {
      for (const node of label.childNodes) {
        if (node.nodeType === Node.TEXT_NODE) {
          const raw = node.textContent.trim().replace(/:$/, '');
          const clean = optionNames[raw];
          if (clean) node.textContent = node.textContent.replace(raw, clean);
        }
      }
    });

    // Button/pill radio labels
    el.querySelectorAll('input[type="radio"]').forEach((input) => {
      const label = el.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (!label) return;
      const optionName = input.dataset.optionName || '';
      const valueMap = getValueMap(map, optionName);
      const clean = valueMap[input.value];
      if (!clean) return;
      for (const node of label.childNodes) {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === input.value) {
          node.textContent = clean;
          break;
        }
      }
    });

    // Dropdown <option> elements — preserve "Sold out" suffix
    el.querySelectorAll('select').forEach((select) => {
      const optionName = select.name ? select.name.replace(/^options\[(.+)\]$/, '$1') : '';
      const valueMap = getValueMap(map, optionName);
      select.querySelectorAll('option').forEach((option) => {
        const clean = valueMap[option.value];
        if (!clean) return;
        const text = option.textContent.trim();
        if (text === option.value) {
          option.textContent = clean;
        } else if (text.startsWith(option.value)) {
          option.textContent = clean + text.slice(option.value.length);
        }
      });
    });

    // [data-selected-value] spans
    el.querySelectorAll('[data-selected-value]').forEach((span) => {
      const container = span.closest('fieldset, .product-form__input');
      const optionName = container?.querySelector('input[type="radio"], select')?.dataset?.optionName
        || container?.querySelector('select')?.name?.replace(/^options\[(.+)\]$/, '$1')
        || '';
      const valueMap = getValueMap(map, optionName);
      const raw = span.textContent.trim();
      const clean = valueMap[raw];
      if (clean) span.textContent = clean;
    });
  }

  function initVariantSelects(el) {
    const map = getMap(el);
    if (!map) return;

    applyMap(el, map);

  }

  function init() {
    document.querySelectorAll('variant-selects').forEach(initVariantSelects);
  }

  // Watch the document for new variant-selects elements added by Dawn's fetch re-render
  const docObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches('variant-selects')) {
          initVariantSelects(node);
        } else {
          node.querySelectorAll('variant-selects').forEach(initVariantSelects);
        }
      });
    });
  });

  docObserver.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
